import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'react-relay';

import { useEditorContentFragment } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import type { EditorContentFragmentResult } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';

import type { useLabelsLabelCountQuery$data } from './__generated__/useLabelsLabelCountQuery.graphql.ts';
import type { useLabelsFragment_content$key } from './__generated__/useLabelsFragment_content.graphql.ts';

const labelsFragmentNode: GraphQLTaggedNode = graphql`
	fragment useLabelsFragment_content on Content @catch {
		id
		labels(orderBy: { sortField: LABELLING_CREATIONDATE, direction: ASCENDING }) {
			count
		}
	}
`;

export function useLabelsFragment(
	contentId: string,
): EditorContentFragmentResult<useLabelsLabelCountQuery$data> {
	return useEditorContentFragment<useLabelsFragment_content$key, useLabelsLabelCountQuery$data>(
		'labelsFragment',
		labelsFragmentNode,
		{
			contentId,
			mapData: (value) => ({ content: { nodes: [value] } }),
		},
	);
}
